import { FC } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";

interface ShareMenuProps {
  menuOpen: boolean;
  handleMenuClose: () => void;
}

export const ShareMenu: FC<ShareMenuProps> = ({
  menuOpen,
  handleMenuClose,
}) => {
  const menuItems = [
    {
      id: "facebook",
      name: "Facebook",
      icon: "./images/logo/facebook.png",
      link: `https://www.facebook.com/sharer/sharer.php?u=${window.location}`,
    },
    {
      id: "x",
      name: "X",
      icon: "./images/logo/twitter.png",
      link: `https://twitter.com/intent/tweet?url=${window.location}`,
    },
    {
      id: "whatsapp",
      name: "WhatsApp",
      icon: "./images/logo/whatsapp.png",
      link: `https://api.whatsapp.com/send?text=${document.title} ${window.location}`,
    },
    {
      id: "copy",
      name: "Kopyala",
      icon: "./images/copy.png",
      link: window.location.toString(),
    },
  ];

  const menuRef = useOutsideClick(handleMenuClose);

  if (!menuOpen) {
    return null;
  }

  return (
    <div ref={menuRef} id="share-menu">
      {menuItems.map((item) => (
        <button
          key={item.id}
          className="share-menu-item"
          onClick={() => {
            if (item.id === "copy") {
              navigator.clipboard.writeText(item.link).then(() => {
                console.log("Link copied to clipboard!");
              });
            } else {
              window.open(item.link, "_blank");
            }
            handleMenuClose();
          }}
        >
          <span>{item.name}</span>
          <img src={item.icon} alt={item.id} />
        </button>
      ))}
    </div>
  );
};
